import React, { Component } from "react";
import PropTypes from "prop-types";
import Loading from "./Loading"; // Keep this if you want to show a loader

export default class MotivationLetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      letter: props.letter ?? "",
    };
  }

  syncParent = (newLetter) => {
    this.props.collectState("MotivationLetter", { letter: newLetter });
  };

  render() {
    const { loading, letter } = this.state;
    const maxLength = 1000;

    if (loading) {
      return <Loading />;
    }

    return (
      <div className="motivation-letter-section">
        <p>
          Write a short motivation letter. Explain why you chose your selected
          major, highlighting your passions and goals. Include any hobbies,
          extracurricular activities, and relevant work or training experiences
          that have shaped your interests and prepared you for this field.
        </p>
        <p style={{ color: "black" }}>
          Click next to navigate to the next section
        </p>

        <textarea
          maxLength={maxLength}
          rows={10}
          value={letter}
          placeholder="Tell us what drives you to choose this major: your passions, hobbies, and goals."
          style={{
            width: "100%",
            resize: "vertical",
            padding: "8px",
            fontSize: "14px",
            fontFamily: "inherit",
            boxSizing: "border-box",
          }}
          onChange={(e) => {
            const val = e.target.value;
            this.setState({ letter: val }, () => this.syncParent(val));
          }}
        />

        <div
          style={{
            textAlign: "right",
            fontSize: "12px",
            marginTop: "5px",
            color: "#666",
          }}
        >
          {letter.length} / {maxLength} characters
        </div>

        {this.props.error?.general && (
          <p
            style={{
              color: "red",
              fontSize: 12,
              marginTop: 3,
              marginBottom: 5,
            }}
          >
            {this.props.error.general}
          </p>
        )}

        <button
          className="save"
          onClick={() => {
            this.props.onSave();
          }}
        >
          Next
        </button>
      </div>
    );
  }
}

MotivationLetter.propTypes = {
  incompleteApplicationId: PropTypes.number,
  onSave: PropTypes.func.isRequired,
  collectState: PropTypes.func.isRequired,
  letter: PropTypes.string,
};
